import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSkipsData } from '../context/SkipsDataContext';
import { useResponsive } from '../hooks/useResponsive';

const ViewToggle = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { companyName } = useSkipsData();
    const viewport = useResponsive();

    const isMapView = location.pathname === '/map';
    const isRecordsView = location.pathname === '/records';
    const isLogView = location.pathname === '/log';
    const isDriversView = location.pathname === '/drivers';
    const isInventoryView = location.pathname === '/inventory';

    const getButtonStyle = (isActive) => ({
        padding: viewport.isMobile ? '6px 10px' : '8px 20px',
        backgroundColor: isActive ? '#166534' : 'transparent',
        color: isActive ? 'white' : '#57534E',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: viewport.isMobile ? '12px' : '14px',
        fontWeight: '500',
        transition: 'all 150ms ease',
        boxShadow: isActive ? '0 1px 3px rgba(28, 25, 23, 0.06)' : 'none'
    });

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            height: '50px',
            backgroundColor: 'white',
            borderBottom: '1px solid #E7E5E4',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: viewport.isMobile ? '0 8px' : '0 20px',
            zIndex: 1002,
            boxShadow: '0 1px 3px rgba(28, 25, 23, 0.06)'
        }}>
            {/* Company Name on the left */}
            <div style={{
                fontSize: viewport.isMobile ? '12px' : '14px',
                fontWeight: '600',
                color: '#292524',
                ...(viewport.isMobile && {
                    maxWidth: '90px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                })
            }}>
                {companyName}
            </div>

            {/* View Toggle in the center */}
            <div style={{
                display: 'flex',
                backgroundColor: '#F5F5F4',
                borderRadius: '6px',
                padding: viewport.isMobile ? '2px' : '4px',
                gap: viewport.isMobile ? '2px' : '4px'
            }}>
                <button
                    onClick={() => navigate('/map')}
                    style={getButtonStyle(isMapView)}
                >
                    Map
                </button>
                <button
                    onClick={() => navigate('/records')}
                    style={getButtonStyle(isRecordsView)}
                >
                    Records
                </button>
                <button
                    onClick={() => navigate('/log')}
                    style={getButtonStyle(isLogView)}
                >
                    Log
                </button>
                <button
                    onClick={() => navigate('/drivers')}
                    style={getButtonStyle(isDriversView)}
                >
                    Drivers
                </button>
                <button
                    onClick={() => navigate('/inventory')}
                    style={getButtonStyle(isInventoryView)}
                >
                    Inventory
                </button>
            </div>

            {/* Placeholder for symmetry - hidden on mobile */}
            <div style={{ width: viewport.isMobile ? '0px' : '100px' }}></div>
        </div>
    );
};

export default ViewToggle;
